import axios from "axios";
const {API} = require("./Auth/backend");
export const Signin = async (userData)=> axios.post(`${API}/clogin`,userData);
export const createuser = async (values)=> axios.post(`${API}/users`,values);
export const createworkersheet = async (data) => axios.post(`${API}/worksheets`,data);
export const create_invoicesheet = async (invoicedata) => {
   return axios.post(`${API}/invoices`, invoicedata,{headers:{
       'Content-Type':'multipart/form-data; boundary=someArbitraryUniqueString',
}})}
export const getOrderid = (page, type) =>
  axios.get(
    `${API}/invoices?type=ALL&page=${page}&size=5${type.site}${type.supplier}${type.invoiceType}${type.paymentStatus}${type.FromDate}${type.ToDate}`,
  );

  export const getInvoiceidformanager = (uid,page, type) =>
  axios.get(
    `${API}/getinvoicesformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.paymentStatus}${type.supplier}${type.invoiceType}${type.FromDate}${type.ToDate}`,
  );
export const addfuelReconsilations = async (data) => {
  return axios.post(`${API}/fuelReconsilation`, data,{headers:{
      'Content-Type':'multipart/form-data; boundary=someArbitraryUniqueString',
}})}
export const getfuelreconsilation = async (uid,type) =>axios.get(`${API}/fuelReconsilation?userid=${uid}&${type.Date}`);
export const getfuelreconsilationPrevDay = async (uid) => axios.get(`${API}/fuelReconsilation?userid=${uid}`);
export const updatefuelreconsilation = async (recordid,data) => axios.put(`${API}/fuelReconsilation/${recordid}`,data);
export const getfuelReconsilationbyId = async (recordid) =>axios.get(`${API}/fuelReconsilationbyId/${recordid}`);
export const getfuelreconsilationforSA = async (type) =>axios.get(`${API}/fuelReconsilationforSA?${type.Date}${type.site}`);
export const createdocket = async (deliverydata) => axios.post(`${API}/deliveryDocket`, deliverydata);
export const createmaintenance = async (data) =>axios.post(`${API}/MaintenanceSheet`,data,{headers:{
    'Content-Type':'application/json; boundary=someArbitraryUniqueString',}});
export const addincidents = async (data) =>axios.post(`${API}/incidents`,data);
export const adddriveoffs = async (data) =>axios.post(`${API}/driveOffs`,data);
export const addinabilities = async (data) =>axios.post(`${API}/inabilities`,data);
export const getusers = async () =>axios.get(`${API}/users`);
export const getinvoices = async () =>axios.get(`${API}/invoices`);
export const getUserByID = (id) => axios.get(`${API}/users/${id}`);
export const UpdateuserByID = (id,data) => axios.put(`${API}/users/${id}`,data);
export const deleteUserByID = (id) => axios.delete(`${API}/users/${id}`);
export const paperworkpost = async (id,data) =>axios.put(`${API}/daysheetPaperWork/${id}`,data);
export const getepaytotal = async ()=> axios.get(`${API}/daysheetPaperWork`);
export const getInvoiceByID = async (id) =>axios.get(`${API}/invoices/${id}`);
export const deleteInvoiceByID = async (id) =>axios.delete(`${API}/invoices/${id}`);
export const Addsiteorsupplier = async (data) =>axios.post(`${API}/createsiteorsupplier`,data);
export const getsiteorsupplier = async () =>axios.get(`${API}/getsiteorsupplier`);
export const UpdateInvoiceByID = async (id,data) => { 
  return axios.put(`${API}/invoices/${id}`,data,{headers:{
  'Content-Type':'multipart/form-data; boundary=someArbitraryUniqueString'}})}
export const getworkersheetByID = async (id) => axios.get(`${API}/worksheets/${id}`);
export const UpdateWokersheetByID = (id,data) => axios.put(`${API}/worksheets/${id}`,data);
export const getdeliveryDocket = async () =>axios.get(`${API}/deliveryDocket`);
export const deletedeliveryDocket = async (id) =>axios.delete(`${API}/deliveryDocket/${id}`);
export const getdeliveryDocketByID = async (id,data) =>axios.get(`${API}/deliveryDocket/${id}`,data);
export const UpdatedeliveryDocket = async (id,data) =>axios.put(`${API}/deliveryDocket/${id}`,data);
export const getMaintanencesearch = async () =>axios.get(`${API}/MaintenanceSheet`);
export const updateMaintanence = async (id,data) =>axios.put(`${API}/MaintenanceSheet/${id}`,data);
export const deleteMaintanence = async (id) =>axios.delete(`${API}/MaintenanceSheet/${id}`);
export const getMaintanenceByID = async (id) =>axios.get(`${API}/MaintenanceSheet/${id}`);
export const getincidents = async () =>axios.get(`${API}/incidents`);
export const getincidentsByID = async (id) =>axios.get(`${API}/incidents/${id}`);
export const deleteincidentsByID = async (id) =>axios.delete(`${API}/incidents/${id}`);
export const updateincidentsByID = async (id,data) =>axios.put(`${API}/incidents/${id}`,data);
export const getdriveOffs = async () =>axios.get(`${API}/driveOffs`);
export const getdriveOffsByID = async (id) =>axios.get(`${API}/driveOffs/${id}`);
export const UpdatedriveOffsByID = async (id,data) =>axios.put(`${API}/driveOffs/${id}`,data);
export const deletedriveOffsByID = async (id) =>axios.delete(`${API}/driveOffs/${id}`);
export const getinabilities = async () =>axios.get(`${API}/inabilities`);
export const getinabilitiesByID = async (id) =>axios.get(`${API}/inabilities/${id}`);
export const UpdateinabilitiesByID = async (id,data) =>axios.put(`${API}/inabilities/${id}`,data);
export const deleteinabilitiesByID = async (id) =>axios.delete(`${API}/inabilities/${id}`);
export const getdeliveryDocketforSA= (page, type) =>axios.get(
    `${API}/deliveryDocket?type=ALL&page=${page}&size=5${type.site}${type.Supplier}${type.FromDate}${type.ToDate}`,
  );
  export const getdeliveryDocketformanager= (uid,page, type) =>axios.get(
    `${API}/deliveryDocketformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.Supplier}${type.FromDate}${type.ToDate}`,
  );
  export const getMaintenanceSheetformanager= (uid,page, type) =>axios.get(
    `${API}/MaintenanceSheetformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getMaintenanceSheetforSA= (page, type) =>axios.get(
    `${API}/MaintenanceSheet?type=ALL&page=${page}&size=5${type.site}${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getinbilityforSA= (page, type) =>axios.get(
    `${API}/inabilities?type=ALL&page=${page}&size=5${type.site}${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getinbilityformanager= (uid,page, type) =>axios.get(
    `${API}/inabilitiesformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getdriveOffsformanager= (uid,page, type) =>axios.get(
    `${API}/driveOffsformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.Rego}${type.FromDate}${type.ToDate}`,
  );
  export const getdriveOffsforSA= (page, type) =>axios.get(
    `${API}/driveOffs?type=ALL&page=${page}&size=5${type.site}${type.Rego}${type.FromDate}${type.ToDate}`,
  );
  export const getincidentsforSA= (page, type) => axios.get(
    `${API}/incidents?type=ALL&page=${page}&size=5${type.site}${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getincidentsformanager= (uid,page, type) =>
  axios.get(
    `${API}/incidentsformanager?userid=${uid}&type=ALL&page=${page}&size=5${type.Status}${type.FromDate}${type.ToDate}`,
  );
  export const getworkersheet = async (uid,type) => axios.get(`${API}/worksheets?userid=${uid}${type.Date}`);
  export const getworkersheetforSA = async (type) => axios.get(`${API}/worksheets?${type.site}${type.Date}${type.ToDate}${type.Category}`);
  export const getallworkersheet = async () => axios.get(`${API}/worksheets`);
  export const getworkersheetformanager  = async () => axios.get(`${API}/worksheetsforManager`);
  export const addbankdetails = async (data) =>axios.post(`${API}/bankDetails`,data);
  export const getbankdetails = async () =>axios.get(`${API}/bankDetails`);
  export const getbankdetailsByID = async (id) =>axios.get(`${API}/bankDetails/${id}`);
  export const updatebankdetailsByID = async (id,data) =>axios.put(`${API}/bankDetails/${id}`,data);
  export const changepwdapi = async (id,data) =>axios.put(`${API}/changepassword/${id}`,data);
  export const Addleave = async (data) =>axios.post(`${API}/leaves`,data);
  export const getleaves = async (data) =>axios.get(`${API}/allLeaves`);
  export const getleavesfornotifications = async () =>axios.get(`${API}/leaves`);
  export const getleavesbyuserid = async (uid) =>axios.get(`${API}/leaves/${uid}`);
  export const updateleavesapi = async (id,data) =>axios.put(`${API}/leaves/${id}`,data);
  export const uploadroaster = async (data) =>axios.post(`${API}/roaster`,data,{headers:{
    'Content-Type':'multipart/form-data; boundary=someArbitraryUniqueString',
}});
export const getroaster = async (uid) =>axios.get(`${API}/getroaster/${uid}`);